// extracted by mini-css-extract-plugin
export default {"rikiTiki":"RikiTiki_rikiTiki__yr86x"};